import http from "../http";

export function useAdTemplateScript() {
  const getTemplateScripts = (templateId) => http.get(`/api/templates/${templateId}/scripts`);
  const scriptIsFullFilled = (script) => script.title

  return {
    getTemplateScripts,
    scriptIsFullFilled,
  }
}
